import React from 'react';
import {
  CLING_SPIRIT_IMG,
  CLING_SPIRIT_SIZES,
  type ClingSpiritSize,
} from '../../lib/melody/clingSpiritAsset';

interface ClingSpiritImageProps {
  size?: ClingSpiritSize;
  filter?: string;
  className?: string;
  alt?: string;
}

export const ClingSpiritImage: React.FC<ClingSpiritImageProps> = ({
  size = 'md',
  filter = 'none',
  className = '',
  alt = 'Espíritu musical',
}) => {
  const px = CLING_SPIRIT_SIZES[size];
  return (
    <img
      src={CLING_SPIRIT_IMG}
      alt={alt}
      draggable={false}
      className={`cling-spirit-img ${className}`.trim()}
      style={{
        width: px,
        height: px,
        objectFit: 'contain',
        filter: filter && filter !== 'none' ? filter : undefined,
      }}
    />
  );
};

export default ClingSpiritImage;
